import classNames from 'classnames/bind';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Commands from './01_Commands';
import Fences from './02_Fences';
import styles from './index.module.scss';

import { FunctionButton } from '@/components/ui/kit/Button';

const cx = classNames.bind(styles);

const Lists = () => {
  const editorMode = useSelector((state) => state.editor.mode);
  const [activeTab, setActiveTab] = useState('commands');

  useEffect(() => {
    if (!editorMode) return;

    if (editorMode.startsWith('fence')) {
      setActiveTab('fences');
    } else {
      setActiveTab('commands');
    }
  }, [editorMode]);

  const selectTab = (e) => {
    setActiveTab(e.currentTarget.dataset.tab);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('header')}>
        <div className={cx('buttons')}>
          <FunctionButton
            text="Commands"
            type="large"
            pressed={activeTab === 'commands'}
            data-tab="commands"
            onClick={selectTab}
            className={cx('button')}
          />
          <FunctionButton
            text="Fences"
            type="large"
            pressed={activeTab === 'fences'}
            data-tab="fences"
            onClick={selectTab}
            className={cx('button')}
          />
        </div>
      </div>
      <div className={cx(['tabpane', { show: activeTab === 'commands' }])}>
        <Commands />
      </div>
      <div className={cx(['tabpane', { show: activeTab === 'fences' }])}>
        <Fences />
      </div>
    </div>
  );
};

export default Lists;
